import React, { useCallback, useContext, useState } from 'react';
import Modal from '@atlaskit/modal-dialog';

import Form from 'kingpin/forms/Form';
import FormHeader from 'kingpin/forms/FormHeader';
import FormContent from 'kingpin/forms/FormContent';
import FormInput from 'kingpin/forms/FormInput';
import TextInput from 'kingpin/atoms/TextInput';
import Typography from 'kingpin/atoms/Typography';
import Button from 'kingpin/atoms/Button';
import Row from 'components/Common/Row';
import { PortalsContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/PortalsProvider';
import { UIVersionContext } from 'contextProviders/SplashScreenProviders/UserAndAccountProviders/UIVersionProvider';

import getTabArtifactInfo from '../tabArtifactInfo';

const TabLabelEditorModal = ({
  tab,
  onSave,
  onClose,
}: {
  tab: EntityDetails.ClientTab;
  onSave: (label: string) => void;
  onClose: () => void;
}) => {
  const { selectedPortal } = useContext(PortalsContext);
  const { isV3 } = useContext(UIVersionContext);
  const [label, setLabel] = useState<string>(tab.label ?? '');

  const { typeLabel, link } = getTabArtifactInfo({
    tab,
    portal: selectedPortal,
    isV3,
  });

  const onSaveClicked = useCallback(() => {
    onSave(label);
    onClose();
  }, [label, onClose, onSave]);

  return (
    <Modal onClose={onClose}>
      <Form>
        <FormHeader title={'Edit Tab'} onClose={onClose} />
        <FormContent>
          <FormInput label={'Tab type'}>
            <Typography.Body type={'Body 12'}>{typeLabel}</Typography.Body>
          </FormInput>
          <FormInput label={'Original'}>
            {link ? (
              <Button
                size={'Small'}
                type={'Secondary'}
                icon={'open-link'}
                label={`Open ${typeLabel}`}
                testId={'open-tab-artifact'}
                onClick={() => window.open(link, '_blank')}
              />
            ) : (
              <Typography.Body
                type={'Body 12'}
                color={'var(--color-text-muted)'}
              >
                No linkable artifact
              </Typography.Body>
            )}
          </FormInput>
          <FormInput label={'Label'}>
            <TextInput
              value={label}
              placeholder={tab.assetName}
              onChange={(e) => setLabel(e.target.value)}
              data-testid={'tab-label-input'}
              autoFocus
            />
          </FormInput>
        </FormContent>
        <Row style={{ justifyContent: 'flex-end', gap: 8, padding: 16 }}>
          <Button
            size={'Small'}
            type={'Secondary'}
            label={'Cancel'}
            onClick={onClose}
          />
          <Button
            size={'Small'}
            type={'Primary'}
            label={'Save'}
            testId={'save-tab-label'}
            onClick={onSaveClicked}
          />
        </Row>
      </Form>
    </Modal>
  );
};

export default TabLabelEditorModal;
